module.exports = __webpack_public_path__ + "static/media/learncode5.6ae16a7d.svg";